import { render, staticRenderFns } from "./Orderslist.vue?vue&type=template&id=e97ab906"
import script from "./Orderslist.vue?vue&type=script&lang=js"
export * from "./Orderslist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports